import { ref } from 'vue'
import { apiService } from '../services/api.js'

/**
 * Composable для управления heartbeat механизмом
 * Отправляет периодические сигналы активности на сервер
 */
export function useHeartbeat(userId, intervalMs = 30000) {
  const isActive = ref(false)
  let heartbeatInterval = null
  let visibilityHandler = null
  let currentUserId = userId

  const sendHeartbeat = async () => {
    const userIdToUse = currentUserId
    if (!userIdToUse) return

    try {
      await apiService.sendHeartbeat(userIdToUse)
      isActive.value = true
    } catch (error) {
      console.warn('Heartbeat failed:', error)
      isActive.value = false
    }
  }

  const startHeartbeat = (newUserId = null) => {
    // Обновляем userId если передан новый
    if (newUserId) {
      currentUserId = newUserId
    }
    
    if (!currentUserId || heartbeatInterval) return

    // Отправляем сразу при старте
    sendHeartbeat()

    // Затем отправляем периодически
    heartbeatInterval = setInterval(() => {
      if (!document.hidden) {
        sendHeartbeat()
      }
    }, intervalMs)

    // Отслеживаем видимость страницы
    if (typeof window !== 'undefined') {
      visibilityHandler = () => {
        if (!document.hidden) {
          sendHeartbeat()
        }
      }
      document.addEventListener('visibilitychange', visibilityHandler)
    }
  }

  const stopHeartbeat = () => {
    if (heartbeatInterval) {
      clearInterval(heartbeatInterval)
      heartbeatInterval = null
    }

    if (typeof window !== 'undefined' && visibilityHandler) {
      document.removeEventListener('visibilitychange', visibilityHandler)
      visibilityHandler = null
    }

    isActive.value = false
  }

  // Автоматически запускаем если userId передан
  if (userId) {
    startHeartbeat()
  }

  return {
    isActive,
    startHeartbeat,
    stopHeartbeat,
    sendHeartbeat
  }
}

